import './App.css';
import React, { useEffect, useState } from 'react'
import { Link, Routes, Route } from 'react-router-dom';
import Card from './components/Card';
import DateTime from './components/DateTime';
import ButtonUI from './components/ButtonUI';
import Layout from './components/Layout';
import Pagination from './components/Pagination';
import Grid from './components/Grid';





function App() {
  const [color, setColor] = useState(false);
  const [isActive, setActive] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResizeWindow = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResizeWindow);
    return () => {
      window.removeEventListener("resize", handleResizeWindow);
    };
  }, [width]);

  const toggleClass = () => {
    if (width < 600) {
      setActive(!isActive);
    }
  };

  const toggleColor = () => {
    setColor(!color);
  }




  return (
    <div className={`wrapper ${color ? 'dark' : 'light'}`}>
      <div className={`side-bar ${isActive ? 'hide-item' : 'show-item'}`}>
        <div className='nav'>
          <ButtonUI text="Show All Projects" lightMode={color ? 'card-dark' : 'card-light'} />
          <label className="switch">
            <input onClick={toggleColor} type="checkbox" name="toggleSwitch" id="toggleSwitch" />
            <span className="slider round"></span>
          </label>
        </div>

        <center><DateTime color={color ? 'title-white' : 'title-black'} /></center>













        <Link className='text-link' onClick={toggleClass} to="/">
          <Card classProp={color ? 'card-dark' : 'card-light'} type="Info" titleColor={color ? 'title-white' : 'title-black'} iconUrl="e230f1880dc0c650bf6bc4dc36ec5bfe.jpg" iconAlt="icon" title="Design Threads" description="A collaborative digital report and exhibition unraveling the state of design today" />
        </Link>
        <Link className='text-link' onClick={toggleClass} to="/nike-be-true">
          <Card classProp={color ? 'card-dark' : 'card-light'} titleColor={color ? 'title-white' : 'title-black'} type="Projects" iconUrl="f5a8c42b03e6ee909784b6387c9e2c4a.jpg" iconAlt="icon" title="Nike Be True" description="A platform to spotlight and celebrate LGBTQIA+ athletes and creators" />
        </Link>

     
          <Card classProp={color ? 'card-dark' : 'card-light'} titleColor={color ? 'title-white' : 'title-black'} type="Projects" iconUrl="1.png" iconAlt="icon" title="Museu Nacional" description="Reimagining the Museu Design Experience " />

        <Card classProp={color ? 'card-dark' : 'card-light'} titleColor={color ? 'title-white' : 'title-black'} type="Projects" iconUrl="2.jpg" iconAlt="icon" title="UpWork" description="A people-first identity system for the pioneer of remote work" />

        <Card classProp={color ? 'card-dark' : 'card-light'} titleColor={color ? 'title-white' : 'title-black'} type="Projects" iconUrl="3.jpg" iconAlt="icon" title="Electric Sky" description="Unconventional branding for an unconventional wine brand" />

        <Card classProp={color ? 'card-dark' : 'card-light'} titleColor={color ? 'title-white' : 'title-black'} type="Projects" iconUrl="4.png" iconAlt="icon" title="From the Grounds Up" description="Creating a dynamic design system for Nike's new editorial series" />

      </div>
      <div className={`layout ${isActive ? 'show-item' : ''}`}>

        <Routes>

          <Route path="/" element={<Layout><div className='nav'><button onClick={toggleClass} className={`${color ? 'card-dark' : 'card-light'} buttonui button ${isActive ? 'show-item' : ''}`}><span className="padding-sm">Back</span></button></div><img src="secondImage.png" alt='mockup'/><img src="firstImage.png" alt='mockup'/><img src="thirdImage.png" alt='mockup'/></Layout>} />

          <Route path="/nike-be-true" element={<Layout><div className='nav'><button onClick={toggleClass} className={`${color ? 'card-dark' : 'card-light'} buttonui button ${isActive ? 'show-item' : ''}`}><span className="padding-sm">Back</span></button></div><img src="forthImage.jpg" alt='mockup'/><img src='fifthImage.jpg'/></Layout>} />






        </Routes>

      </div>

    </div>
  )
}

export default App


